import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { assertIsError } from '../../../../../utils/assert-is-error';
import { logger } from '../../../../../utils/logger';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { getCurrentMemberSubscription } from '../../../selectors/member/subscriptions/get-current-member-subscription';
import { loadMember } from '../load-member';
export const cancelCurrentMemberSubscription = async () => {
    if (!isMemberSignedIn())
        throw new Error('Cannot cancel subscription when no user is signed in.');
    const memberSubscription = getCurrentMemberSubscription();
    if (!memberSubscription) {
        throw new Error('Cannot cancel subscription when member details have not been loaded or member has no current subscription.');
    }
    if (memberSubscription.cancelsAt) {
        throw new Error('Cannot cancel a subscription that has already been cancelled.');
    }
    try {
        await ocapiClient.instance.v1.loyalty.members.subscriptions.cancelCurrent();
        await loadMember(true); // Loading member again to reflect the newly set data.
    }
    catch (error) {
        assertIsError(error);
        logger.error(error.message);
        throw error;
    }
};
